export default "__VITE_ASSET__B3pEej72__"